import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { useAnalytics } from '@utils';
import { LocaleLink, AuthLink, ButtonSecondary } from '@common/components';
import { retrieveAccessToken, validateToken } from '@utils';
import styles from './List.module.scss';
import { getLanguagePrefix } from '@helpers';
import { LanguageSwitch } from '../SidebarNavigation/LanguageSwitch';

export const List = ({
  items = [],
  className,
  renderToggle,
  location,
  invertTheme = false,
  user,
}) => {
  const { trackInteraction } = useAnalytics();
  const configuratorPage =
    location &&
    location.pathname &&
    location.pathname.indexOf('/air/configure') !== -1
      ? true
      : false;
  const subscribePage =
    location &&
    location.pathname &&
    location.pathname.indexOf('/subscribe') !== -1
      ? true
      : false;
  const noNewsPortal = item => {
    const show =
      location &&
      location.pathname &&
      location.pathname.indexOf('/portal') > -1 &&
      item.link.uri === '#newsletter'
        ? false
        : true;
    return show;
  };
  const { prefixLanguage: language } = useSelector(({ appState }) => appState);

  const token = retrieveAccessToken();
  const isAuth = validateToken(token);
  const itemURI = 'internal:/portal/login/';

  return (
    <ul className={classNames(styles.list, className)}>
      {items.map(item => {
        const linkType = item.link.options.attributes?.type || null;

        return (
          <Fragment key={item.drupal_id}>
            {item?.link?.uri === itemURI && (
              <li className={`${styles.item} ${styles.langSwitch}`}>
                <LanguageSwitch />
              </li>
            )}
            {linkType === 'button' ? (
              noNewsPortal(item) &&
              !isAuth && (
                <li className={classNames(styles.item, styles.stayUpdated)}>
                  <ButtonSecondary
                    className={styles.button}
                    link={
                      configuratorPage || subscribePage
                        ? { href: '/subscribe', withLanguage: true }
                        : {
                            href: item.link.uri.replace('internal:', ''),
                          }
                    }
                    label={item.title}
                    isSmall
                    isDark={false}
                  />
                </li>
              )
            ) : linkType === 'auth' ? (
              <AuthLink
                menu="MAIN_NAVIGATION"
                item={item}
                styles={styles}
                isAuth={isAuth}
                user={user}
              />
            ) : (
              <li className={classNames(styles.item, styles.itemWithLink)}>
                <LocaleLink
                  to={
                    window.location.origin +
                    getLanguagePrefix(language) +
                    item.link.uri.replace('internal:', '')
                  }
                  className={classNames(styles.link, {
                    [styles.invert]: invertTheme,
                  })}
                  onClick={() => {
                    trackInteraction(
                      'main-navigation',
                      item.title,
                      item.link.uri.replace('internal:', ''),
                      'main-navigation'
                    );
                  }}
                >
                  <span className={styles.label}>{item.title}</span>
                </LocaleLink>
              </li>
            )}
          </Fragment>
        );
      })}
      {renderToggle && (
        <li className={classNames(styles.item)} key="toggle">
          {renderToggle()}
        </li>
      )}
    </ul>
  );
};

List.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderToggle: PropTypes.func,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  user: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    reservations: PropTypes.arrayOf(PropTypes.object),
  }),
};

List.defaultProps = {
  className: null,
  renderToggle: null,
};
